import { Button } from "@/components/ui/button";
import { Home, ArrowLeft, Search } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function Page404() {
  const navigate = useNavigate();

  return (
    <div className="py-32 flex items-center justify-center  px-4">
      <div className="text-center max-w-lg mx-auto">
        {/* Animated 404 illustration */}
        <div className="relative mb-8">
          <div className="text-[180px] font-black text-primary/10 leading-none select-none">
            404
          </div>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="relative">
              <div className="w-24 h-24 rounded-full bg-primary/10 flex items-center justify-center animate-pulse">
                <Search className="w-12 h-12 text-primary/60" />
              </div>
              <div className="absolute -top-1 -right-1 w-6 h-6 rounded-full bg-destructive flex items-center justify-center">
                <span className="text-destructive-foreground text-xs font-bold">
                  !
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="space-y-4 mb-8">
          <h1 className="text-lg font-bold text-foreground tracking-tight">
            Oops! Page not found
          </h1>
          <p className="text-muted-foreground text-[15px] leading-relaxed max-w-md mx-auto">
            The page you're looking for doesn't exist or has been moved. Let's
            get you back on track.
          </p>
        </div>

        {/* Action buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Button
            variant="default"
            size="lg"
            className="w-full sm:w-auto gap-2"
            onClick={() => navigate("/choose-module")}
          >
            <Home className="w-4 h-4" />
            Back to Home
          </Button>
          <Button
            variant="outline"
            size="lg"
            className="w-full sm:w-auto gap-2"
            onClick={() => navigate(-1)}
          >
            <ArrowLeft className="w-4 h-4" />
            Go Back
          </Button>
        </div>

        {/* Help text */}
        <p className="mt-8 text-sm text-muted-foreground">
          Need help?{" "}
          <button
            onClick={() => navigate("/support")}
            className="text-primary hover:underline font-medium"
          >
            Contact Support
          </button>
        </p>
      </div>
    </div>
  );
}
